import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Typography } from '@material-ui/core'
import gameResultSectionStyles from './gameResultSection.styles'
import ButtonWithLoader from '../../ui/ButtonWithLoader/ButtonWithLoader'
import TextButton from '../../ui/TextButton/TextButton'
import COLORS from '../../../utils/constants/colors'

const useStyles = makeStyles(gameResultSectionStyles)

const InlineConfirmation = ({
  title,
  text,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  isLoading,
  danger,
}) => {
  const classes = useStyles()

  return (
    <div className={`${classes.confirmBox} ${danger ? classes.confirmBoxDanger : ''}`} role='alert'>
      <Typography className={classes.resultText}>{title}</Typography>
      <Typography className={classes.confirmText}>{text}</Typography>
      <div className={classes.panelActions}>
        <TextButton type='button' label={cancelLabel} onClick={onCancel} disabled={isLoading} />
        <ButtonWithLoader
          type='button'
          data-testid='confirm-action-confirm'
          label={confirmLabel}
          onClick={onConfirm}
          loading={isLoading}
          style={danger ? { backgroundColor: COLORS.red } : undefined}
        />
      </div>
    </div>
  )
}

InlineConfirmation.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  isLoading: PropTypes.bool,
  danger: PropTypes.bool,
}

InlineConfirmation.defaultProps = {
  isLoading: false,
  danger: false,
}

export default InlineConfirmation
